/**
  * Director.
  * 
  * Manages scenes and the config and variables for the active scene.
  *
  */

// Globals.
import $ from 'jQuery';
import THREE from 'THREE';

export default class Director {
  constructor(options) {
    
  }
}
